import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, Optional } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { fabric } from 'fabric';
import * as Hammer from 'hammerjs';
import { element } from 'protractor';
import { AppSettings } from 'src/app/app-settings';
import { AreasSeatService } from 'src/app/services/areas-seat.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NominativeService } from 'src/app/services/nominative.service';
import { SeatMapService } from 'src/app/services/seat-map.service';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { TicketsService } from 'src/app/services/tickets.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { LoginComponent } from '../../shared/login/login.component';
import { LoginCardComponent } from '../login-card/login-card.component';
import { GenerateMapService } from 'src/app/services/generate-map.service';
import { fromEvent } from 'rxjs';
import { fixedPassPrice, isFixedPricePass } from 'src/app/utils/fixed-price-pass.util';

@Component({
  selector: 'app-seats-panel',
  templateUrl: './seats-panel.component.html',
  styleUrls: ['./seats-panel.component.scss'],
})
export class SeatsPanelComponent implements OnInit {
  fromAbono!: any;
  // Abono de butaca única: el mapa es el del abono entero (no el de una
  // sesión) y no hay tarifa que elegir, la resuelve el back en cada evento.
  singleSeatPass: boolean = false;
  abono!: any;
  abonoQuantity: number = 1;

  // Selección de butaca para un abono deportivo (una sola butaca; sin tickets).
  seasonPassMode: boolean = false;
  // seats.id de la butaca ya asignada al abono/socio, para preseleccionarla.
  currentSeatId: number | null = null;
  // Elemento fabric de esa butaca asignada: se guarda para mantenerla siempre
  // resaltada en rosa de marca aunque se clique encima o se elija otra distinta.
  private seasonPassAssignedEl: any = null;

  // Bloqueos del recinto presentes en el mapa (PMR, cabinas, butacas
  // retiradas...), como seats.id. Para el público son intocables; el panel de
  // control puede liberarlos con el interruptor "Permitir butacas bloqueadas"
  // (ver toggleBlockedSelection) para poder dar de alta o renovar un abono ahí.
  blockedSeatIds: number[] = [];
  // Ocupadas y reservadas, sin los bloqueos: es lo que queda sin poder elegirse
  // cuando se liberan los bloqueos. Una butaca puede estar a la vez bloqueada y
  // ocupada por otro abonado, y esas no las libera el interruptor.
  private unavailableSeatIds: number[] = [];
  // Grupos de bloqueo (nombre + color + butacas) tal y como están configurados
  // en el mapa del recinto: es lo que permite pintar cada bloqueo con su color
  // y decir de cuál se trata en lugar de un genérico "butaca bloqueada".
  blockedGroups: { name: string, color: string, seat_ids: number[] }[] = [];
  private blockedGroupBySeatId: { [id: number]: { name: string, color: string } } = {};
  // Solo el panel de control abre el mapa con esto a true: es lo que muestra el
  // interruptor. Sin él, los bloqueos se comportan como siempre.
  allowBlockedSelection: boolean = false;
  // Estado del interruptor. Apagado (por defecto) => los bloqueos se comportan
  // exactamente igual que en el flujo público: grises y no seleccionables.
  blockedUnlocked: boolean = false;
  // Color de un bloqueo liberado cuando su grupo no tiene color configurado.
  colorBlockedFallback = '#8E7CC3';

  profile!: any;
  clicked: boolean = false;

  event!: any;
  canvas: fabric.Canvas;
  hammer: Hammer.HammerManager;

  objectMap!: any;
  selectTickets: any[] = [];
  pausePanning = true;
  selectedSeats: any[] = [];
  activedSeat!: any;

  totalPrice: any = 0;
  optionSection!: any;

  dateSelect!: any;
  timeSelect!: any;

  // Default colors
  colorDefaultSeat = '#d7d7d7';
  colorDefaultStand = this.areaSeatService.colorDefaultStand;
  colorDefaultFree = this.areaSeatService.colorDefaultFree;
  colorDefaultStage = this.areaSeatService.colorDefaultStage;
  colorDefaultHidden = this.areaSeatService.colorDefaultHidden;
  colorDefaultSelect = this.areaSeatService.colorDefaultSelect;
  colorDefaultMovility = this.areaSeatService.colorDefaultMovility;
  colorDefaultSpecial = '';

  // Comprobar compras de evento, en la fecha y horas seleccionadas
  buysBuySelect: any[] = [];

  // HiddenSeat
  hiddenCode!: string;
  savedCode!: string;
  errorCode: boolean = false;
  openFormDiscount: boolean = false;
  discountObject!: any;

  enabled: number = 0;
  invite: boolean = false;
  checkInvite: boolean = false;

  openDetail: boolean = true;
  openLegend: boolean = false;
  // Configuración de la leyenda (null => leyenda por defecto, retrocompatible).
  legendConfig: any = null;
  // Filas resueltas que se pintan en la leyenda del comprador.
  legendEntries: { label: string, color: string }[] = [];
  organizer: boolean = false;
  addedSeatToast: string | null = null;
  toastFading: boolean = false;
  private toastTimer: any;
  private toastFadeTimer: any;

  loaded!: boolean;
  selectedAbono: any[] = [];

  // Areas section
  areas: any[] = [];
  infoSectionActive!: any;
  mapBySections: boolean = false;

  totemActive: any = AppSettings.ENV_TOTEM;
  private initialZoom: number = 1;
  lastPosX: number = 0;
  lastPosY: number = 0;

  sessionSelected!: any;
  seatSections: { [key: number]: any } = {};
  // ¿Todas las secciones del mapa nombran la butaca (showSeatLabelOnTicket)? Si alguna no lo
  // hace —grada, pista, zonas sin butaca numerada— los textos generales del panel no pueden
  // hablar de "butaca". Se calcula una sola vez al cargar el mapa porque lo consultan bindings
  // de la plantilla y las secciones ya no cambian.
  mapHasSeatLabels: boolean = true;
  canvasObjects: { [key: string]: any } = {};
  objectIdCounter: number = 1;
  screenElement: string = '/assets/img/canvas/screen-users-light.svg';
  shoesElement: string = '/assets/img/canvas/shoe-prints-light.svg';
  sectionNumber: number = 1;
  ticketsEnabled: any[] = [];
  levelSelected: any;
  previousLevelSelected: any; // Para guardar el valor anterior del nivel
  sectionsEnabled: any[] = [];
  levelsEnabled: any[] = [];

  // Navegación por zonas (opt-in). Si está desactivado o no hay zonas → comportamiento actual.
  // navPreview = escena del plano general (dibujo libre desacoplado del mapa de butacas).
  zoneNavigation: boolean = false;
  navPreview: any[] = [];
  inOverview: boolean = false;
  navZoneObjects: any[] = [];
  // true mientras se muestra el mapa completo (acción "Ver mapa completo").
  showingFullMap: boolean = false;
  // Zona enfocada actualmente (null en overview o en mapa completo).
  selectedZone: any = null;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SeatsPanelComponent>,
    private areaSeatService: AreasSeatService,
    private shoppingCart: ShoppingCartService,
    private ticketsService: TicketsService,
    private auth: AuthenticationService,
    private generateMapService: GenerateMapService,
    private cdr: ChangeDetectorRef,
    private nominativeService: NominativeService,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    this.profile = this.auth.getProfile();
    this.event = this.data.event;
    this.sessionSelected = this.data.session;
    // Modo "selección de butaca de abono": reutiliza todo el render del mapa de
    // compra pero sin evento/sesión/tickets. La ocupación llega ya resuelta en
    // objectMap.booked_seats (seats.id de abonos+legacy) y al confirmar se
    // devuelve una única butaca (ver confirmSeasonPassSeat).
    this.seasonPassMode = this.data.seasonPassMode || false;
    this.currentSeatId = this.data.currentSeatId ?? null;
    this.ticketsEnabled = (this.data.tickets || []).filter((ticket: any) => !ticket.only_tpv_sales);
    if (this.event?.company?.id == 3) {
      this.colorDefaultSpecial = '#f3ad33';
      this.colorDefaultMovility = '#4ab1ff';
    }
    this.objectMap = this.data.mapEvent;
    this.levelsEnabled = this.objectMap.levels.sort((a: any, b: any) => b.name.localeCompare(a.name));
    this.sectionsEnabled = this.objectMap.sections;
    // Flags de navegación por zonas (mapas antiguos no los traen → desactivado).
    // Se soporta tanto camelCase como snake_case por si el backend devuelve cualquiera.
    this.zoneNavigation = !!(this.objectMap.zoneNavigation || this.objectMap.zone_navigation);
    // Escena del plano general de zonas (columna dedicada map_nav_preview). Cada objeto trae
    // su tipo y configuración (polígono/rect/escenario/texto); las zonas clicables llevan
    // configuration.sections con las secciones de butacas a las que hacen zoom.
    this.navPreview = this.objectMap.navPreview || this.objectMap.map_nav_preview || [];
    // Si llegó preview pero el flag no vino en el API, lo derivamos de su presencia.
    if (!this.zoneNavigation && this.navPreview.length > 0) {
      this.zoneNavigation = true;
    }
    this.buysBuySelect = [...new Set([...(this.objectMap.booked_seats || []), ...(this.objectMap.reserved_seats || []), ...(this.objectMap.blocked_seats || [])])];
    this.enabled = ((this.event?.space?.capacity || 0) - this.buysBuySelect.length);
    // Los bloqueos entran en buysBuySelect como el resto (mapa idéntico al del
    // público mientras el interruptor esté apagado), pero se guardan aparte para
    // poder sacarlos de ahí sin tocar las ocupadas si se liberan.
    this.blockedSeatIds = [...new Set<number>((this.objectMap.blocked_seats || []).map((id: any) => +id))];
    this.unavailableSeatIds = [...new Set<number>(
      [...(this.objectMap.booked_seats || []), ...(this.objectMap.reserved_seats || [])].map((id: any) => +id)
    )];
    this.allowBlockedSelection = this.data.allowBlockedSelection || false;
    this.indexBlockedGroups(this.data.blockedGroups || []);
    this.openDetail = window.innerWidth > 998 ? true : false;
    // Leyenda: config del mapa (camelCase o snake_case). null en mapas antiguos → filas por defecto.
    this.legendConfig = this.objectMap.legendConfig || this.objectMap.legend_config || null;
    this.buildLegendEntries();
    // this.openLegend = window.innerWidth > 767 ? true : false;
    this.fromAbono = this.data.fromAbono || false;
    this.singleSeatPass = this.data.singleSeatPass || false;
    this.abono = this.data.abono || null;
    this.abonoQuantity = this.data.abonoQuantity || 1;
    this.organizer = this.data.organizer;
    // Abono de precio fijo evento a evento: las zonas sin precio en este evento
    // no entran en el abono y se pintan como no disponibles, igual que en el
    // mapa del abono de butaca única. Si aun así se pulsa una (no debería poder),
    // getEnabledTickets() la rechaza.
    const outOfPassSeatIds = this.fixedPassOutOfPassSeatIds();
    if (outOfPassSeatIds.length > 0) {
      this.buysBuySelect = [...new Set([...this.buysBuySelect, ...outOfPassSeatIds])];
      this.unavailableSeatIds = [...new Set([...this.unavailableSeatIds, ...outOfPassSeatIds])];
      this.enabled = ((this.event?.space?.capacity || 0) - this.buysBuySelect.length);
    }
    // if (this.fromAbono) {
    //   this.selectedAbono = this.data.tickets ? this.data.tickets : [];
    //   if (this.data.tickets && this.data.actived) {
    //     this.activedSeat = this.data.actived;
    //     this.getEnabledTickets();
    //   }
    // }

    if (this.objectMap) {
      // Los niveles son obligatorios
      const levels = this.objectMap.levels;
      this.generateMapService.setLevelsMap(levels);

      const configuration = this.objectMap.configuration;
      if (configuration) {
        this.generateMapService.setObjectsMap(configuration);
      }

      // ✅ Agrupar secciones y asientos desde objectMap
      if (this.objectMap.sections && this.objectMap.seats) {
        const seatSections = this.groupSectionsAndSeats(this.objectMap.sections, this.objectMap.seats);
        this.generateMapService.setSeatSections(seatSections);
      }
    }

    this.loadSectionsFromStorage();
  }

  // ✅ Método para convertir array a objeto de clave-valor
  convertArrayToKeyValueObject(configurationArray: any[]): { [key: string]: any } {
    const result: { [key: string]: any } = {};

    if (Array.isArray(configurationArray)) {
      configurationArray.forEach(item => {
        // Cada item es un objeto con una clave que contiene los datos
        const keys = Object.keys(item);
        if (keys.length > 0) {
          const key = keys[0]; // obj_1, obj_2, etc.
          result[key] = item[key]; // Asignar el valor completo
        }
      });
    }

    return result;
  }

  /**
   * Butacas (seats.id) de las zonas sin precio en este evento para un abono de
   * precio fijo comprado evento a evento. El mapa de la butaca única ya llega
   * filtrado del back. Una butaca se agrupa por su sección lógica igual que en
   * groupSectionsAndSeats(); como ese id puede repetirse entre niveles, solo se
   * deja fuera si ninguna sección con ese id tiene precio.
   */
  private fixedPassOutOfPassSeatIds(): number[] {
    if (!this.fromAbono || this.singleSeatPass || !isFixedPricePass(this.abono) || !this.sessionSelected?.id) {
      return [];
    }

    const sections: any[] = this.objectMap?.sections || [];
    const pricedSections = new Set(
      sections
        .filter((s: any) => fixedPassPrice(this.abono, this.sessionSelected.id, s.id_level) != null)
        .map((s: any) => `${s.id_section}`)
    );

    return (this.objectMap?.seats || [])
      .filter((seat: any) => seat?.id != null && !pricedSections.has(`${seat.section}`))
      .map((seat: any) => +seat.id);
  }

  // ✅ Método para agrupar secciones y asientos (si es necesario)
  groupSectionsAndSeats(sections: any[], seats: any[]): any[] {
    const seatSections: any[] = [];

    sections.forEach(section => {
      // Filtrar asientos que pertenecen a esta sección
      const sectionSeats = seats.filter(seat => seat.section === section.id_section);
      const sectionObject = {
        id: section.id_section,
        name: section.name,
        seats: sectionSeats.length,
        color: section.color,
        columns: section.configuration?.seatsGroupConfig.columns,
        rows: section.configuration?.seatsGroupConfig.rows,
        configuration: section.configuration,
        id_bbdd: section.id
      };

      seatSections.push({
        section: sectionObject,
        elements: sectionSeats
      });
    });

    return seatSections;
  }

  loadSectionsFromStorage() {
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        this.seatSections = storedSections;
      } catch (error) {
        this.seatSections = {};
      }
    }
    this.mapHasSeatLabels = Object.values(this.seatSections || {}).every(
      (sectionData: any) => sectionData?.section?.configuration?.seatsGroupConfig?.showSeatLabelOnTicket !== false
    );

    // ✅ Cargar otros objetos del canvas (escenarios, etc.)
    const storedObjects = this.generateMapService.getObjectsMap();
    if (storedObjects) {
      try {
        this.canvasObjects = storedObjects;

        // Actualizar el contador de objetos
        const objectIds = Object.keys(this.canvasObjects).map(id => {
          // Buscar números en el ID usando regex
          const match = id.match(/(\d+)$/); // Busca números al final del string
          return match ? parseInt(match[1]) : 0;
        }).filter(num => num > 0); // Filtrar números válidos

        if (objectIds.length > 0) {
          this.objectIdCounter = Math.max(...objectIds) + 1;
        }
      } catch (error) {
        this.canvasObjects = {};
      }
    }

    this.areas = this.generateMapService.getLevelsMap();
    this.discountObject = this.generateMapService.getBlockedSeats();
  }

  ngAfterViewInit(): void {
    this.canvas = new fabric.Canvas('myCanvas', {
      backgroundColor: '#f5f5f5',
      selection: false,
    });

    this.setupCanvasAfterLayout();
  }

  // En móvil el diálogo aún puede estar animándose/reflowando cuando ngAfterViewInit
  // se ejecuta, por lo que el contenedor puede medir 0x0. Reintentamos en el siguiente
  // frame hasta que tenga dimensiones reales (con un límite para no bucear infinito).
  private setupCanvasAfterLayout(retriesLeft: number = 30, previous: { width: number, height: number } | null = null): void {
    const container = document.getElementById('canvas-container');
    const containerWidth = container?.clientWidth ?? 0;
    const containerHeight = container?.clientHeight ?? 0;

    // Además de tener tamaño, tiene que haberse quedado quieto de un frame al
    // siguiente: con el mapa como primer diálogo abierto (evento de una sola
    // sesión, sin el calendario debajo) el contenedor mide en móvil menos de lo
    // que acaba ocupando un frame después, y el canvas se quedaba estrecho con
    // una franja en blanco al lado.
    const settled = previous?.width === containerWidth && previous?.height === containerHeight;
    if ((containerWidth === 0 || containerHeight === 0 || !settled) && retriesLeft > 0) {
      requestAnimationFrame(() =>
        this.setupCanvasAfterLayout(retriesLeft - 1, { width: containerWidth, height: containerHeight })
      );
      return;
    }

    this.initCanvas(containerWidth || 800, containerHeight || 600);
  }

  private initCanvas(containerWidth: number, containerHeight: number): void {
    // Establecer el canvas con el mismo tamaño que el contenedor
    this.canvas.setDimensions({
      width: containerWidth,
      height: containerHeight,
    });

    this.recreateSectionsFromStorage();
    this.canvas.renderAll();

    if (this.areas.length > 0) {
      this.mapBySections = true;
      this.colorDefaultSeat = this.areaSeatService.colorDefaultSeat;
    }

    // Calcular zoom y centrado basado en el contenido
    const objects = this.canvas.getObjects();
    if (objects.length > 0) {
      // Calcular el bounding box de todos los objetos
      let minX = Infinity;
      let minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;

      objects.forEach((obj) => {
        const bound = obj.getBoundingRect(true);
        minX = Math.min(minX, bound.left);
        minY = Math.min(minY, bound.top);
        maxX = Math.max(maxX, bound.left + bound.width);
        maxY = Math.max(maxY, bound.top + bound.height);
      });

      const contentWidth = maxX - minX;
      const contentHeight = maxY - minY;
      const contentCenterX = minX + contentWidth / 2;
      const contentCenterY = minY + contentHeight / 2;

      // En móvil el panel de "entradas seleccionadas" se muestra flotando sobre
      // la parte inferior del canvas, así que esa franja no es realmente visible.
      // La descontamos para calcular zoom y centrado, si no el mapa queda pegado abajo.
      const bottomInset = this.getBottomOverlayInset();
      const usableHeight = containerHeight - bottomInset;

      // Calcular zoom para que todo el contenido sea visible con margen
      const margin = 40; // Margen alrededor del contenido
      const zoomX = (containerWidth - margin * 2) / contentWidth;
      const zoomY = (usableHeight - margin * 2) / contentHeight;
      let zoom = Math.min(zoomX, zoomY);

      // Ajustar límites del zoom
      zoom = Math.min(Math.max(zoom, 0.2), 0.5);

      // Aplicar el zoom
      this.canvas.setZoom(zoom);

      // Calcular el desplazamiento para centrar el contenido en el canvas
      const canvasCenterX = containerWidth / 2;
      const canvasCenterY = usableHeight / 2;

      const offsetX = canvasCenterX - contentCenterX * zoom;
      const offsetY = canvasCenterY - contentCenterY * zoom;

      // Aplicar el viewportTransform para centrar
      this.canvas.setViewportTransform([zoom, 0, 0, zoom, offsetX, offsetY]);

      this.canvas.renderAll();
    } else {
      // Si no hay objetos, zoom por defecto
      if (window.innerWidth >= 576) {
        // this.canvas.setZoom(0.4);
      }
      if (this.totemActive) {
        // this.canvas.setZoom(0.8);
      }
    }

    this.canvas.set('backgroundColor', '#f5f5f5');
    this.canvas.renderAll();

    if (this.fromAbono && this.activedSeat) {
      this.addTicket(this.selectedAbono[0]?.option[0], false);
    }
    this.loaded = true;

    // Preselección (best-effort) de la butaca actual del abono/socio. Si está
    // en una zona aún no visible (navegación por zonas) simplemente no se
    // resalta; no es crítico, el "mantener butaca" se decide en el formulario.
    if (this.seasonPassMode && this.currentSeatId != null) {
      const currentEl = this.findSeatElementById(this.currentSeatId);
      if (currentEl && currentEl.selectable) {
        this.seasonPassAssignedEl = currentEl;
        this.selectTicket(currentEl);
        // Resaltar la butaca asignada con el rosa de marca y encuadrar el mapa
        // sobre ella para que el abonado la localice de un vistazo al abrir.
        this.focusSeasonPassSeat(currentEl);
      }
    }

    this.canvas.on('mouse:down', (e) => {
      // En la vista general por zonas, un click sobre una zona hace zoom a ella.
      if (this.inOverview) {
        if (e.target && e.target.navZone) {
          this.selectNavZone(e.target.navZone);
          return;
        }
        // Click en espacio vacío: activar panning
        if (!e.target && this.pausePanning == true) {
          this.pausePanning = false;
          this.canvas.defaultCursor = 'move';
        }
        e.e.preventDefault();
        e.e.stopPropagation();
        return;
      }
      if (
        e.target &&
        (e.target.eventSeat ||
          (e.target.groupSeat &&
            e.subTargets.length > 0 &&
            e.subTargets[0].eventSeat))
      ) {
        let elementSeat = e.target.groupSeat ? e.subTargets[0] : e.target;
        if (elementSeat.selectable) {
          this.selectTicket(elementSeat);
        }
      }
      if ((!e.target || e.target.isInfoSection) && this.pausePanning == true) {
        this.pausePanning = false;
        this.canvas.discardActiveObject(this.canvas.getActiveObject());
        this.canvas.defaultCursor = 'move';
      }
      e.e.preventDefault();
      e.e.stopPropagation();
    });

    this.canvas.on('mouse:over', (e) => {
      if (
        e.target &&
        (e.target.eventSeat || (e.target.groupSeat && e.subTargets?.length > 0))
      ) {
        let elementSeat = e.target.groupSeat ? e.subTargets[0] : e.target;
        let indexStroke = elementSeat._objects.find(
          (value) => value.type != 'text'
        );
        indexStroke.set('stroke', 'black');
        this.canvas.renderAll();
      }
    });

    this.canvas.on('mouse:out', (e) => {
      if (
        e.target &&
        (e.target.eventSeat || (e.target.groupSeat && e.subTargets?.length > 0))
      ) {
        let elementSeat = e.target.groupSeat ? e.subTargets[0] : e.target;
        let indexStroke = elementSeat._objects.find(
          (value) => value.type != 'text'
        );
        indexStroke.set('stroke', '#4D4D4D');
        this.canvas.renderAll();
      }
    });

    this.canvas.on('mouse:wheel', (opt) => {
      var delta = opt.e.deltaY;
      var zoom = this.getZoom(false, delta);
      var zoomPoint = new fabric.Point(opt.e.pageX, opt.e.pageY);
      this.canvas.zoomToPoint(zoomPoint, zoom);
      this.canvas.renderAll();
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });

    var previousTouch;
    this.canvas.on('mouse:move', (e) => {
      if (this.pausePanning == false && e && e.e) {
        if (!e.e.touches) {
          this.canvas = keepPositionInBounds(this.canvas, e);
        }
        if (e.e.touches && e.e.touches.length == 1) {
          const touch = e.e.touches[0];
          if (previousTouch) {
            // be aware that these only store the movement of the first touch in the touches array
            e.e.movementX = touch.pageX - previousTouch.pageX;
            e.e.movementY = touch.pageY - previousTouch.pageY;
            this.canvas = keepPositionInBounds(this.canvas, e);
          }
          previousTouch = touch;
        }
      }
    });

    this.canvas.on('mouse:up', (e) => {
      previousTouch = null;
      if (!this.canvas.getActiveObject() && this.pausePanning == false) {
        this.pausePanning = true;
        this.canvas.defaultCursor = 'default';
      }
    });

    // Mobile device
    const upperCanvas = document.querySelector(
      '.upper-canvas'
    ) as HTMLCanvasElement;
    upperCanvas.style.touchAction = 'none';
    this.hammer = new Hammer.Manager(upperCanvas, {
      touchAction: 'none', // Evita conflictos con el navegador
    });
    const pinch = new Hammer.Pinch();
    const pan = new Hammer.Pan({ threshold: 0 });
    this.hammer.add([pinch, pan]);

    this.hammer.get('pinch').set({ enable: true });
    this.hammer.get('pan').set({ enable: true });

    // Eventos de zoom
    this.hammer.on('pinchstart', this.handlePinchStart.bind(this));
    this.hammer.on('pinchmove', this.handlePinchMove.bind(this));
    this.hammer.on('pinchend', this.handlePinchEnd.bind(this));

    // Inicializar navegación por zonas si el mapa la tiene activada (opt-in).
    // Se aplaza un tick para que el DOM haya calculado las dimensiones del canvas.
    setTimeout(() => this.initZoneNavigation(), 0);
  }

  recreateSectionsFromStorage() {
    if (Object.keys(this.seatSections).length === 0) {
      return;
    }

    // ✅ Recrear otros objetos del canvas
    if (Object.keys(this.canvasObjects).length > 0) {
      Object.values(this.canvasObjects).forEach((objectData: any) => {
        this.createObjectFromData(objectData);
      });
    }

    Object.values(this.seatSections).forEach((sectionData: any) => {
      this.createSectionFromData(sectionData);
    });

    this.canvas.renderAll();
  }

  // Método para crear una sección desde los datos guardados
  createSectionFromData(sectionData: any) {
    const { section, elements } = sectionData;
    // Las capas ocultadas en el editor (icono de ojo) guardan configuration.hidden = true y no
    // deben renderizarse en el front de usuario.
    if (section?.configuration?.hidden) {
      return;
    }
    const { mainGroup, sectionObject } = this.generateMapService.addGroupSeats(section.rows, section.columns, this.sectionNumber, sectionData, true, this.buysBuySelect);

    this.canvas.add(mainGroup);
  }

  // ✅ Método para crear objetos desde datos guardados
  createObjectFromData(objectData: any) {
    const { type, configuration, id } = objectData;
    // Las capas ocultadas en el editor (icono de ojo) guardan configuration.hidden = true y no
    // deben renderizarse en el front de usuario.
    if (configuration?.hidden) {
      return;
    }
    const configWithId = { ...configuration, objectId: configuration?.objectId || id };

    switch (type) {
      case 'scenary':
        this.recreateScenary(configWithId);
        break;
      case 'polygon':
        this.recreatePolygon(configWithId);
        break;
      case 'rect':
        this.recreateRect(configWithId);
        break;
      case 'ellipse':
        this.recreateEllipse(configWithId);
        break;
      case 'standSection':
        this.recreateStandSection(configWithId);
        break;
      case 'text':
        this.recreateText(configWithId);
        break;
      case 'groupCircles':
        this.createCircleInfo(configWithId);
        break;
      case 'image':
      case 'svg':
        this.recreateImage(configWithId);
        break;
      default:
        console.warn('Tipo de objeto no reconocido:', type);
    }
  }

  // ✅ Métodos para recrear cada tipo de objeto
  async recreateScenary(config: any) {
    const res = await this.generateMapService.createScenary(
      this.canvas,
      config.fill || this.colorDefaultStage,
      this.screenElement,
      config,
      true
    );
    // El escenario carga su SVG de forma asíncrona: si termina después de entrar en el plano
    // general (overview), debe quedar oculto como el resto del mapa de butacas.
    if (res?.group && this.inOverview) {
      res.group.visible = false;
      this.canvas.renderAll();
    }
  }

  recreatePolygon(config: any) {
    let polygon = this.generateMapService.addPoligonObject(config);
    if (polygon.level != null && this.levelsEnabled?.length > 0) {
      const byId = this.levelsEnabled.find((l: any) => +l.id === +polygon.level);
      if (!byId) {
        const found = this.levelsEnabled.find((l: any) => l.id_level != null && +l.id_level === +polygon.level)
          || this.levelsEnabled.find((l: any) => l.orderBuy != null && +l.orderBuy === +polygon.level);
        if (found) polygon.set('level', +found.id);
      }
    }
    polygon = this.generateMapService.limitObjectMovement(polygon);
    this.canvas.add(polygon);
    this.canvas.sendToBack(polygon);
  }

  recreateRect(config: any) {
    let rect = this.generateMapService.addRectObject(config);
    if (rect.level != null && this.levelsEnabled?.length > 0) {
      const byId = this.levelsEnabled.find((l: any) => +l.id === +rect.level);
      if (!byId) {
        const found = this.levelsEnabled.find((l: any) => l.id_level != null && +l.id_level === +rect.level)
          || this.levelsEnabled.find((l: any) => l.orderBuy != null && +l.orderBuy === +rect.level);
        if (found) rect.set('level', +found.id);
      }
    }
    rect = this.generateMapService.limitObjectMovement(rect);
    this.canvas.add(rect);
    this.canvas.sendToBack(rect);
  }

  recreateEllipse(config: any) {
    let ellipse = this.generateMapService.addEllipseObject(config);
    if (ellipse.level != null && this.levelsEnabled?.length > 0) {
      const byId = this.levelsEnabled.find((l: any) => +l.id === +ellipse.level);
      if (!byId) {
        const found = this.levelsEnabled.find((l: any) => l.id_level != null && +l.id_level === +ellipse.level)
          || this.levelsEnabled.find((l: any) => l.orderBuy != null && +l.orderBuy === +ellipse.level);
        if (found) ellipse.set('level', +found.id);
      }
    }
    ellipse = this.generateMapService.limitObjectMovement(ellipse);
    this.canvas.add(ellipse);
    this.canvas.sendToBack(ellipse);
  }

  // Imágenes rasterizadas (configuration.src) y SVG vectoriales (configuration.svg) añadidos en
  // el editor. En el front son decorativos: se pintan bloqueados y sin eventos.
  // Ambos se crean de forma asíncrona (fabric carga el bitmap o parsea el markup), así que se
  // añaden al canvas DESPUÉS de las secciones y de initZoneNavigation. Por eso hay que
  // recolocarlos bajo las butacas y fijar aquí su visibilidad si ya se entró en el plano general.
  async recreateImage(config: any) {
    if (!config?.src && !config?.svg) {
      return;
    }
    const img = config.svg
      ? await this.generateMapService.addSvgObject(config.svg, config)
      : await this.generateMapService.addImageObject(config.src, config);
    if (!img) {
      return;
    }
    if (img.level != null && this.levelsEnabled?.length > 0) {
      const found = this.resolveLevel(img.level);
      if (found) {
        img.set('level', +found.id);
      }
    }
    img.set({ selectable: false, evented: false, hoverCursor: 'default' });
    this.canvas.add(img);
    const firstSeatIndex = this.canvas.getObjects().findIndex((obj: any) => obj.groupSeat);
    if (firstSeatIndex >= 0) {
      this.canvas.moveTo(img, firstSeatIndex);
    }
    if (this.inOverview) {
      img.visible = false;
    }
    this.canvas.renderAll();
  }

  recreateStandSection(config: any) {
    this.recreateGroupInfo(this.shoesElement, config.text || 'Pista', config.color || this.colorDefaultStand, 'Capacidad', config);
  }

  recreateGroupInfo(icon: string, text: string, color: any, subtitle: string, config: any) {
    const rectangle = this.generateMapService.createRect(color, 300, 150);
    const textComponent = this.generateMapService.createTextComponent(text, 18, -30);
    let elements = [rectangle, textComponent];

    if (subtitle) {
      const textCapacity = this.generateMapService.createTextComponent(subtitle, 16, 40);
      elements.push(textCapacity);
    }

    var canvas = this.canvas;
    fabric.loadSVGFromURL(icon, function (objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      obj.set({ top: -5, scaleX: 0.05, scaleY: 0.05, originX: 'center', hasControls: false });
      elements.push(obj);

      var group = new fabric.Group(elements, {
        left: config.left,
        top: config.top,
        width: 300,
        height: 150,
        scaleX: config.scaleX || 1,
        scaleY: config.scaleY || 1,
        angle: config.angle || 0,
        capacity: config.capacity || 50,
        lockRotation: true,
        eventSeat: true,
        isSection: true,
        section: config.section,
        objectId: config.objectId
      });
      group = this.generateMapService.limitObjectMovement(group);
      group.setControlVisible('mtr', false);
      canvas.add(group);
      canvas.renderAll();
    });
  }

  recreateText(config: any) {
    let text = new fabric.Textbox(config.text || 'Escribe un texto...', {
      width: config.width || 200,
      height: config.height || 100,
      fontSize: config.fontSize || 24,
      cursorColor: config.cursorColor || '#FF4D80',
      left: config.left,
      top: config.top,
      scaleX: config.scaleX || 1,
      scaleY: config.scaleY || 1,
      angle: config.angle || 0,
      lineHeight: config.lineHeight || 1,
      fontFamily: config.fontFamily || 'Satoshi-Regular',
      fill: config.fill || '#000000',
      eventSeat: false,
      objectId: config.objectId
    });
    text = this.generateMapService.limitObjectMovement(text);
    this.canvas.add(text);
  }

  createCircleInfo(sectionData: any) {
    let mainGroup = this.generateMapService.addGroupNumbers(sectionData.rows, sectionData.columns, sectionData, true);
    mainGroup = this.generateMapService.limitObjectMovement(mainGroup);
    this.canvas.add(mainGroup);
    this.canvas.renderAll();
  }

  private handlePinchStart(event: any) {
    this.initialZoom = this.canvas.getZoom(); // Guardamos el zoom inicial
  }

  private handlePinchMove(event: any) {
    if (!event.center) return;

    // 1️⃣ Obtener el zoom actual y aplicarle la escala del pinch
    let zoom = this.initialZoom * event.scale;

    // 2️⃣ Limitar el zoom entre un mínimo y máximo
    zoom = Math.max(0.1, Math.min(zoom, 5)); // Cambia los valores si es necesario

    // 3️⃣ Obtener el punto central del evento en coordenadas del canvas
    const point = new fabric.Point(
      event.center.x - this.canvas._offset.left,
      event.center.y - this.canvas._offset.top
    );

    // 4️⃣ Aplicar zoom en ese punto
    this.canvas.zoomToPoint(point, zoom);
    this.canvas.renderAll();
  }

  private handlePinchEnd(event: any) {
    this.initialZoom = this.canvas.getZoom(); // Resetear para el siguiente gesto
    this.hammer.get('pinch').set({ enable: true });
  }

  resizeCanvasToFitObjects() {
    const objects = this.canvas.getObjects();
    if (!objects.length) return;

    // Obtener los límites exactos de todos los objetos
    const boundingRect = objects.reduce(
      (acc, obj) => {
        const { left, top, width, height } = obj;
        return {
          minX: Math.min(acc.minX, left),
          minY: Math.min(acc.minY, top),
          maxX: Math.max(acc.maxX, left + width),
          maxY: Math.max(acc.maxY, top + height),
        };
      },
      { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity }
    );

    // Calcular el nuevo tamaño del canvas
    const newWidth = boundingRect.maxX - boundingRect.minX;
    const newHeight = boundingRect.maxY - boundingRect.minY;

    // Redimensionar el canvas
    this.canvas.setDimensions({ width: newWidth, height: newHeight });

    // Ajustar la posición de los objetos al nuevo centro
    const dx = -boundingRect.minX;
    const dy = -boundingRect.minY;

    objects.forEach((obj) => {
      obj.set({
        left: obj.left + dx,
        top: obj.top + dy,
      });
      obj.setCoords();
    });

    this.canvas.renderAll();
  }

  setCenterCanvas(json: any) {
    this.canvas.loadFromJSON(json, () => {
      this.canvas.renderAll();

      // Obtener límites de los objetos en el canvas
      const objects = this.canvas.getObjects();
      const boundingRect = this.canvas.getObjects().reduce(
        (acc, obj) => {
          const { left, top, width, height } = obj;
          return {
            minX: Math.min(acc.minX, left),
            minY: Math.min(acc.minY, top),
            maxX: Math.max(acc.maxX, left + width),
            maxY: Math.max(acc.maxY, top + height),
          };
        },
        { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity }
      );

      // Calcular centro de los objetos
      const contentWidth = boundingRect.maxX - boundingRect.minX;
      const contentHeight = boundingRect.maxY - boundingRect.minY;

      const canvasCenterX = this.canvas.width / 2;
      const canvasCenterY = this.canvas.height / 2;

      const contentCenterX = boundingRect.minX + contentWidth / 2;
      const contentCenterY = boundingRect.minY + contentHeight / 2;

      // Mover todos los objetos al centro del canvas
      const dx = canvasCenterX - contentCenterX;
      const dy = canvasCenterY - contentCenterY;

      objects.forEach((obj) => {
        obj.set({
          left: obj.left + dx,
          top: obj.top + dy,
        });
        obj.setCoords();
      });

      this.canvas.renderAll();
    });
  }

  // Botones externos de zoom
  zoomMap(plus: boolean, event: any, delta: any = 50) {
    let zoom = this.getZoom(plus, delta * 4);
    this.canvas.setZoom(zoom);
    var zoomPoint = this.canvas.getVpCenter();
    // this.canvas.zoomToPoint(zoomPoint, zoom);
    this.canvas.renderAll();
    event.stopPropagation();
  }

  getZoom(plus: boolean, delta: any = 50) {
    var zoom = this.canvas.getZoom();
    var plusDelta = plus ? -delta : delta;
    zoom *= 0.999 ** plusDelta;
    if (zoom > 10) zoom = 10;
    if (zoom < 0.2) zoom = 0.2;
    return zoom;
  }

  // Qué parte de la posición enseña la sección de una butaca. Los flags no viven en la
  // butaca sino en la configuración de su sección dentro del mapa; el backend los vuelca
  // a map_sections.show_row/show_seat_label al publicar. Ausentes => true (mapas antiguos).
  private sectionTicketLabels(sectionId: any): { showRow: boolean; showSeatLabel: boolean } {
    const sectionData: any = Object.values(this.seatSections || {}).find(
      (value: any) => value?.section?.id == sectionId
    );
    const sgc = sectionData?.section?.configuration?.seatsGroupConfig;
    return {
      showRow: sgc?.showRowOnTicket !== false,
      showSeatLabel: sgc?.showSeatLabelOnTicket !== false
    };
  }

  /**
   * Cómo llamar a lo que se elige en el plano cuando el texto no va referido a una butaca
   * concreta (mensajes de ayuda, botón sin selección...): "butaca" si todo el mapa las nombra,
   * y "entrada" —que vale para cualquier caso— si hay secciones sin butaca numerada.
   */
  get selectionNoun(): string {
    return this.mapHasSeatLabels ? 'butaca' : 'entrada';
  }

  /** Igual, pero mirando solo lo ya seleccionado: una selección mezclada se resume como "entrada". */
  get selectedNoun(): string {
    return this.selectedSeats.every((seat: any) => seat.showSeatLabel !== false) ? 'butaca' : 'entrada';
  }

  get isNominative(): boolean {
    return this.nominativeService.isNominative(this.event);
  }

  /**
   * Tope de butacas por persona en la sesión, o null si no hay.
   *
   * Espejo de PurchaseLimitService::effectiveLimit en el backend: el más
   * restrictivo entre el 1 que imponen las entradas nominativas y el tope que
   * haya configurado el gestor en la sesión. Es ayuda visual; el recuento real,
   * que suma pedidos anteriores, lo hace el servidor.
   */
  get userSeatLimit(): number | null {
    // El mapa lo comparten la compra de entradas, los abonos y la asignación de
    // butaca de abonado. El tope por usuario es de la venta de entradas: un
    // abono legítimamente ocupa varias butacas (`abonoQuantity`), así que
    // aplicarlo aquí rompería ese flujo.
    if (this.fromAbono || this.seasonPassMode) {
      return null;
    }

    const limits: number[] = [];

    if (this.isNominative) {
      limits.push(1);
    }

    // El tope del gestor se guarda en el evento; los eventos del editor antiguo lo
    // tienen además en la sesión. Igual que en el backend, mandan los dos y gana el
    // más restrictivo.
    const perEvent = this.event?.max_tickets_per_order;
    if (perEvent !== null && perEvent !== undefined && +perEvent > 0) {
      limits.push(+perEvent);
    }

    const perUser = this.sessionSelected?.max_tickets_per_user;
    if (perUser !== null && perUser !== undefined && +perUser > 0) {
      limits.push(+perUser);
    }

    return limits.length > 0 ? Math.min(...limits) : null;
  }

  addTicket(ticket: any, close: boolean = true) {
    if (ticket) {
      let actived = this.activedSeat;

      // Cambiar de butaca sí se permite; pasar del tope por persona, no.
      const isReplacingSameSeat = this.selectedSeats.some(
        (value) => actived.id && value.id == actived.id
      );
      const limit = this.userSeatLimit;
      if (limit !== null && !isReplacingSameSeat && this.selectedSeats.length >= limit) {
        this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: false,
            text: this.isNominative
              ? 'Este evento tiene entradas nominativas: solo puedes comprar 1 entrada por sesión. Deselecciona la butaca elegida si quieres cambiarla.'
              : `Solo puedes comprar ${limit} ${limit === 1 ? 'entrada' : 'entradas'} por persona en esta sesión. Deselecciona alguna butaca si quieres cambiarla.`,
            btnCancel: false,
          },
        });
        return;
      }

      this.activedSeat.selected = true;
      let indexEl = this.selectedSeats.findIndex(
        (value) => actived.id && value.id == actived.id
      );
      const labels = this.sectionTicketLabels(actived.section?.id);
      let object = {
        event: this.event.id,
        id: actived.id,
        section: actived.section,
        row: actived.row,
        seat: actived.seat,
        column: actived.column,
        levelId: this.levelSelected?.id,
        levelName: this.levelSelected?.name,
        showRow: labels.showRow,
        showSeatLabel: labels.showSeatLabel,
        option: ticket,
        element: actived,
        hidden: actived.hidden || false
      };
      this.totalPrice += +ticket.price;
      indexEl != -1
        ? (this.selectedSeats[indexEl] = object)
        : this.selectedSeats.push(object);

      // Al añadir la primera entrada, desplegar el resumen para que se vea la selección.
      if (this.selectedSeats.length === 1) {
        this.openDetail = true;
      }

      // Para flujo de abono con mapas, acumular asientos hasta llegar a la cantidad requerida
      if (this.fromAbono) {
        if (this.selectedSeats.length >= this.abonoQuantity) {
          const cart_lines = this.selectedSeats.map(s => ({
            id_ticket: s.option.id,
            quantity: 1,
            id_seat: s.element.id
          }));
          this.dialogRef.close({
            cart_lines,
            price: this.totalPrice,
            session: this.sessionSelected,
            seats: this.selectedSeats
          });
        } else {
          // Faltan asientos: cerrar el panel de opciones para que el usuario
          // vea el mapa con el asiento marcado y pueda seleccionar el siguiente
          this.closeActived();
        }
      } else {
        // Flujo normal: solo cerrar el panel lateral
        // La sección de la butaca recién elegida manda: si no la nombra (grada/pista), hablar de
        // "butaca" confundiría, así que se dice "entrada".
        const seleccionada = labels.showSeatLabel ? 'Butaca' : 'Entrada';
        const carritoCta = this.selectedSeats.length > 1 ? 'añadirlas al carrito' : 'añadirla al carrito';
        this.showToast(`${seleccionada} seleccionada — Puedes elegir más o ${carritoCta}`);
        this.closeActived();
      }
    }
  }

  showToast(msg: string) {
    clearTimeout(this.toastTimer);
    clearTimeout(this.toastFadeTimer);
    this.addedSeatToast = msg;
    this.toastFading = false;
    this.toastFadeTimer = setTimeout(() => { this.toastFading = true; }, 3500);
    this.toastTimer = setTimeout(() => { this.addedSeatToast = null; this.toastFading = false; }, 4000);
  }

  closeActived(close: boolean = true) {
    if (!this.activedSeat) return;
    this.activedSeat.actived = false;
    let elementStroke = this.activedSeat._objects.find(
      (value) => value.type != 'text'
    );
    if (close && this.mapBySections) {
      this.levelSelected = null;
      this.changeOpacitySections(true);
    }
    // let defaultColor = (this.profile?.admin || (this.profile?.protocolo && this.organizer) && this.activedSeat.level) ? this.activedSeat.level.color : this.colorDefaultSeat;
    let defaultColor = this.activedSeat.level
      ? this.activedSeat.level.color
      : this.colorDefaultSeat;

    let colorFill = this.activedSeat?.selected
      ? this.colorDefaultSelect
      : defaultColor;
    elementStroke.set('fill', colorFill);
    let elementsText = this.activedSeat._objects.filter(
      (value) => value.type == 'text' || value.type == 'path'
    );
    let colorText = this.activedSeat.selected ? 'white' : 'black';
    elementsText.forEach((elementText) => {
      elementText.set('fill', colorText);
    });
    this.canvas.renderAll();
    this.activedSeat = null;

  }

  selectTicket(elementSeat: any) {

    // En modo abono, la butaca ya asignada es una marca permanente: al clicarla
    // se mantiene resaltada en rosa de marca (no se deselecciona) y sigue siendo
    // la selección activa que confirmará "Mantener/Confirmar butaca".
    if (this.seasonPassMode && this.isAssignedSeat(elementSeat)) {
      if (this.activedSeat && !this.isAssignedSeat(this.activedSeat)) {
        this.activeChangeDefault();
      }
      elementSeat.actived = true;
      this.activedSeat = elementSeat;
      const sectionSeat = this.sectionsEnabled.find((s: any) => s.id_section == elementSeat.section?.id);
      this.levelSelected = this.levelsEnabled.find((l: any) => l.id == sectionSeat?.id_level) || null;
      this.previousLevelSelected = this.levelSelected;
      this.paintAssignedSeat();
      this.canvas.renderAll();
      // Los eventos del canvas de Fabric pueden dispararse fuera de la zona de
      // Angular y en modo abono no hay ninguna petición que refresque la vista,
      // así que forzamos la detección de cambios para actualizar el panel.
      this.cdr.detectChanges();
      return;
    }

    elementSeat.actived = elementSeat.actived ? false : true;
    elementSeat.selected = false;

    let sectionSeat = this.sectionsEnabled.find((sectionData: any) => {
      return sectionData.id_section == elementSeat.section?.id;
    });
    let levelSelect = this.levelsEnabled.find((level: any) => level.id == sectionSeat?.id_level);
    this.levelSelected = levelSelect || null;
    this.previousLevelSelected = this.levelSelected;

    let defaultColor = elementSeat.isSection ? this.colorDefaultFree : sectionSeat.color;
    // let color = elementSeat.hidden ? this.hiddenTypeEdit.color : defaultColor;

    // Cambiar color circulo interior
    if (this.activedSeat) {
      this.activeChangeDefault();
    }
    let colorActive = this.mapBySections ? '#ffa2bc' : '#ff4d7f3f';
    let colorBasic = this.mapBySections ? 'white' : defaultColor;
    // En modo abono, al deseleccionar una butaca debe recuperar el color de su
    // nivel (no el blanco de "sección enfocada" que usa el flujo de compra).
    if (this.seasonPassMode) {
      // Un bloqueo liberado vuelve al color de su bloqueo, no al de su nivel:
      // sigue siendo una butaca que el recinto tiene reservada.
      colorBasic = elementSeat.blockedUnlocked
        ? this.blockedColorOf(elementSeat)
        : (elementSeat.level?.color || defaultColor || this.colorDefaultSeat);
    }

    let elementStroke = elementSeat._objects.find(
      (value) => value.type != 'text'
    );
    let colorFill = elementSeat.actived ? colorActive : colorBasic;
    elementStroke.set('fill', colorFill);
    let colorText = 'black';
    if (!elementSeat.actived) {
      let rgb = hexToRgb(colorFill);
      if (rgb) {
        const luminance = rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114;
        // Fondo claro → texto oscuro; fondo oscuro → texto claro. En el flujo de
        // compra la relación estaba invertida; en modo abono usamos la correcta
        // para que el número no quede blanco sobre el amarillo del nivel.
        colorText = this.seasonPassMode
          ? (luminance > 186 ? '#000' : '#fff')
          : (luminance > 186 ? '#fff' : '#000');
      } else {
        colorText = '#000';
      }
    }
    let elementsText = elementSeat._objects.filter(
      (value) => value.type == 'text' || value.type == 'path'
    );
    elementsText.forEach((elementText) => {
      elementText.set('fill', colorText);
    });

    let indexEl = this.selectedSeats.findIndex(
      (value) => elementSeat.id && value.id == elementSeat.id);
    if (indexEl != -1) {
      this.totalPrice -= +this.selectedSeats[indexEl].option.price;
      this.selectedSeats.splice(indexEl, 1);
    }
    this.activedSeat = elementSeat.actived ? elementSeat : null;
    // this.changeOpacitySections();
    // En modo abono no hay tickets: la butaca activa ES la selección; el botón
    // "Confirmar/Mantener butaca" cierra el diálogo con ella (ver confirmSeasonPassSeat).
    // Al deseleccionar una butaca nueva se vuelve a la asignada, que sigue siendo
    // la selección de referencia (marcada en rosa), para no dejar el panel sin opción.
    if (this.seasonPassMode) {
      if (!this.activedSeat) {
        this.selectAssignedSeat();
      }
      this.canvas.renderAll();
      // Igual que en la rama de la butaca asignada: sin petición que refresque la
      // vista, forzamos la detección de cambios para que el panel muestre la info.
      this.cdr.detectChanges();
      return;
    }
    this.getEnabledTickets();
    this.canvas.renderAll();
  }

  /**
   * Cierra el diálogo devolviendo la butaca elegida para un abono deportivo.
   * `id_seat` es la PK física (seats.id); el resto son datos legibles para
   * mostrar el resumen en el formulario. Si no hay butaca activa, no hace nada.
   */
  /**
   * Busca en el canvas el objeto fabric de la butaca cuyo seats.id coincide,
   * ya sea suelta (eventSeat) o dentro de un grupo de sección (groupSeat).
   * Devuelve null si no está renderizada (p. ej. en otra zona).
   */
  private findSeatElementById(id: number): any {
    const objects: any[] = (this.canvas?.getObjects() as any[]) || [];
    for (const obj of objects) {
      if (obj.eventSeat && obj.id === id) return obj;
      if (obj.groupSeat && obj._objects && obj._objects[1] && obj._objects[1]._objects) {
        const seat = obj._objects[1]._objects.find((s: any) => s.eventSeat && s.id === id);
        if (seat) return seat;
      }
    }
    return null;
  }

  /**
   * Resalta la butaca ya asignada al abono con el rosa de marca (color-primary)
   * y encuadra el mapa sobre ella —dejando unas butacas de margen alrededor para
   * dar contexto— para que el abonado la localice nada más abrir el mapa. En
   * mapas con navegación por zonas no se reencuadra (la vista arranca en el plano
   * general), pero el color se mantiene para cuando se entra en la zona.
   */
  private focusSeasonPassSeat(el: any): void {
    this.paintAssignedSeat();

    if (!this.zoneNavigation) {
      // La butaca puede estar anidada en grupos (sección → grupo de butacas),
      // así que su posición absoluta en el canvas se obtiene componiendo las
      // transformaciones de todos los grupos padre. calcTransformMatrix() lo hace
      // y su traslación (m[4], m[5]) es el centro de la butaca en coordenadas de
      // mundo; qrDecompose da la escala absoluta para dimensionar el margen.
      const m = el.calcTransformMatrix();
      const decomposed = fabric.util.qrDecompose(m);
      const cx = m[4];
      const cy = m[5];
      const worldW = (el.width || 20) * Math.abs(decomposed.scaleX);
      const worldH = (el.height || 20) * Math.abs(decomposed.scaleY);
      // ~10 butacas de margen a cada lado para dar contexto sin perder de vista la propia.
      const padX = worldW * 10;
      const padY = worldH * 10;
      this.fitToBounds(
        {
          minX: cx - padX,
          minY: cy - padY,
          maxX: cx + padX,
          maxY: cy + padY,
        },
        0.2,
        2,
        40,
      );
    }
    this.canvas.renderAll();
  }

  /** True si el elemento es la butaca ya asignada al abono (comparación por seats.id). */
  private isAssignedSeat(el: any): boolean {
    return !!el && this.currentSeatId != null && el.id === this.currentSeatId;
  }

  /**
   * True si la butaca activa es una butaca NUEVA (distinta de la ya asignada):
   * distingue en el panel "butaca actual" de "butaca nueva elegida" y cambia el
   * texto del botón entre "Mantener" y "Elegir esta butaca".
   */
  get isNewSeatSelected(): boolean {
    return !!this.activedSeat && !this.isAssignedSeat(this.activedSeat);
  }

  /** Pinta la butaca asignada con el rosa de marca (relleno primary, texto blanco). */
  private paintAssignedSeat(): void {
    const el = this.seasonPassAssignedEl;
    if (!el) return;
    const stroke = el._objects?.find((v: any) => v.type != 'text');
    if (stroke) {
      stroke.set('fill', '#FF4D80');
    }
    (el._objects || [])
      .filter((v: any) => v.type == 'text' || v.type == 'path')
      .forEach((t: any) => t.set('fill', '#fff'));
  }

  /**
   * Vuelve a dejar la butaca ya asignada como selección activa (marcada en rosa
   * de marca): es la referencia a la que se cae cuando se deselecciona una
   * butaca nueva o cuando la elegida deja de estar disponible, para no dejar el
   * panel sin ninguna opción que confirmar.
   */
  private selectAssignedSeat(): void {
    if (!this.seasonPassAssignedEl) return;
    this.seasonPassAssignedEl.actived = true;
    this.activedSeat = this.seasonPassAssignedEl;
    const assignedSection = this.sectionsEnabled.find((s: any) => s.id_section == this.seasonPassAssignedEl.section?.id);
    this.levelSelected = this.levelsEnabled.find((l: any) => l.id == assignedSection?.id_level) || null;
    this.previousLevelSelected = this.levelSelected;
    this.paintAssignedSeat();
  }

  /**
   * Indexa los grupos de bloqueo por butaca para resolver en O(1) "de qué
   * bloqueo es esta butaca" al pintar y al avisar. Solo cuentan las butacas que
   * el mapa ya trae por bloqueadas: los grupos llegan de la tabla de bloqueos
   * del recinto, que también guarda los de los eventos que se celebran ahí.
   */
  private indexBlockedGroups(groups: any[]): void {
    this.blockedGroups = [];
    this.blockedGroupBySeatId = {};
    const blocked = new Set(this.blockedSeatIds);

    (groups || []).forEach((group: any) => {
      const seatIds = (group?.id_seats || group?.seat_ids || [])
        .map((id: any) => +id)
        .filter((id: number) => blocked.has(id));
      if (seatIds.length === 0) return;

      const entry = {
        name: group.name || 'Bloqueada',
        color: group.color || this.colorBlockedFallback,
      };
      this.blockedGroups.push({ ...entry, seat_ids: seatIds });
      seatIds.forEach((id: number) => this.blockedGroupBySeatId[id] = entry);
    });
  }

  /** Grupo de bloqueo de una butaca, o null si no está bloqueada. */
  private blockedGroupOf(el: any): { name: string, color: string } | null {
    if (!el || el.id == null) return null;
    const id = +el.id;
    if (!this.blockedSeatIds.includes(id)) return null;
    return this.blockedGroupBySeatId[id] || { name: 'Bloqueada', color: this.colorBlockedFallback };
  }

  /** Color con el que se pinta un bloqueo liberado: el de su propio grupo. */
  private blockedColorOf(el: any): string {
    return this.blockedGroupOf(el)?.color || this.colorBlockedFallback;
  }

  /**
   * Bloqueo de la butaca activa, para avisar en el resumen de que se va a
   * asignar una butaca que el recinto tiene reservada. Getter y no estado para
   * que no haya nada que sincronizar en cada selección.
   */
  get activedBlockedGroup(): { name: string, color: string } | null {
    if (!this.seasonPassMode || !this.blockedUnlocked) return null;
    return this.blockedGroupOf(this.activedSeat);
  }

  /**
   * Interruptor "Permitir butacas bloqueadas" (solo panel de control). Liberar
   * los bloqueos del recinto puede acabar en un abono vendido en una plaza PMR o
   * en una cabina, así que es un gesto deliberado: se confirma una vez y a
   * partir de ahí los bloqueos quedan clicables —pintados con el color de su
   * grupo— hasta que se vuelva a apagar. Las butacas ocupadas por otros
   * abonados no se tocan: esas siguen siendo intocables también aquí.
   */
  toggleBlockedSelection(enable: boolean): void {
    if (!this.allowBlockedSelection) return;

    if (!enable) {
      this.applyBlockedSelection(false);
      return;
    }

    // El propio mat-slide-toggle ya se ha pintado encendido, así que el valor
    // tiene que ir con él para que Angular pueda devolverlo a apagado si se
    // cancela la confirmación.
    this.blockedUnlocked = true;

    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        warning: true,
        btnCancel: true,
        textButton: 'Permitir',
        text: 'Vas a poder asignar butacas que el recinto tiene bloqueadas (PMR, cabinas, butacas retiradas...). Se marcarán en el plano con el color de su bloqueo. Las butacas ocupadas por otros abonados seguirán sin poder elegirse.',
      },
    }).afterClosed().subscribe((confirmed: any) => {
      this.applyBlockedSelection(!!confirmed);
    });
  }

  /**
   * Aplica el estado del interruptor sobre el mapa ya renderizado, sin
   * reconstruirlo: mueve los bloqueos dentro o fuera de `buysBuySelect` (la
   * lista de butacas no seleccionables) y repinta solo esas butacas.
   */
  private applyBlockedSelection(unlocked: boolean): void {
    this.blockedUnlocked = unlocked;

    // Al liberar solo se quitan los bloqueos: las ocupadas y reservadas siguen
    // fuera de juego, incluidas las que además estén bloqueadas.
    const occupied = new Set(this.unavailableSeatIds);
    const blocked = new Set(this.blockedSeatIds.filter((id: number) => !occupied.has(id)));
    this.buysBuySelect = unlocked
      ? [...this.unavailableSeatIds]
      : [...new Set([...this.unavailableSeatIds, ...this.blockedSeatIds])];
    this.enabled = ((this.event?.space?.capacity || 0) - this.buysBuySelect.length);

    // Al volver a bloquear, una butaca bloqueada no puede seguir siendo la
    // elegida ni la referencia "butaca actual" del abono.
    if (!unlocked) {
      if (this.activedSeat && blocked.has(+this.activedSeat.id)) {
        this.activedSeat.actived = false;
        this.activedSeat = null;
      }
      if (this.seasonPassAssignedEl && blocked.has(+this.seasonPassAssignedEl.id)) {
        this.seasonPassAssignedEl = null;
      }
    }

    blocked.forEach((id: number) => {
      const el = this.findSeatElementById(id);
      // Solo butacas reales del mapa: las que no son eventSeat (invisibles,
      // retiradas del plano) no se pueden elegir por mucho que se desbloqueen.
      if (!el || !el.eventSeat) return;
      el.hidden = !unlocked;
      // Marca propia: canvasColorLevels y la deselección repintan según
      // hidden/nivel, y sin esto le devolverían el gris de "no disponible" o el
      // color del nivel, perdiendo el del bloqueo.
      el.blockedUnlocked = unlocked;
      el.selectable = unlocked;
      el.hoverCursor = unlocked ? 'pointer' : 'default';
      if (!unlocked) {
        el.actived = false;
      }
      changeSeatColor(el, unlocked ? this.blockedColorOf(el) : this.colorDefaultHidden);
    });

    // La butaca del abono o del socio puede caer dentro de un bloqueo (mapa
    // nuevo con bloqueos encima de butacas históricas): al liberarlos ya se
    // puede preseleccionar, y "Mantener butaca" vuelve a tener sentido.
    if (unlocked && this.currentSeatId != null && !this.seasonPassAssignedEl && blocked.has(+this.currentSeatId)) {
      const currentEl = this.findSeatElementById(this.currentSeatId);
      if (currentEl?.selectable) {
        this.seasonPassAssignedEl = currentEl;
        this.selectTicket(currentEl);
      }
    } else if (!this.activedSeat) {
      this.selectAssignedSeat();
    }

    this.buildLegendEntries();
    this.canvas.renderAll();
    this.cdr.detectChanges();
  }

  confirmSeasonPassSeat() {
    if (!this.activedSeat) return;
    const seat = this.activedSeat;
    // Si sigue seleccionada la butaca ya asignada, no hay cambio: se cierra sin
    // devolver nada y el formulario conserva la butaca del carné.
    if (this.isAssignedSeat(seat)) {
      this.dialogRef.close();
      return;
    }
    this.dialogRef.close({
      id_seat: seat.id,
      row: seat.row,
      seat: seat.seat,
      column: seat.column,
      section: seat.section || null,
      level: this.levelSelected
        ? { id: this.levelSelected.id, name: this.levelSelected.name }
        : null,
    });
  }

  activeChangeDefault() {
    // La butaca asignada del abono nunca vuelve a su color por defecto: conserva
    // siempre su marca en rosa aunque se seleccione otra distinta.
    if (this.seasonPassMode && this.isAssignedSeat(this.activedSeat)) {
      this.activedSeat.actived = false;
      this.paintAssignedSeat();
      return;
    }
    this.activedSeat.actived = false;
    // let defaultColorActive = (this.profile?.admin || (this.profile?.protocolo && this.organizer)) && this.activedSeat.level ? this.activedSeat.level.color : this.colorDefaultSeat;
    // let colorDefault = this.mapBySections ? 'white' : '';

    // if(this.mapBySections){
    //   let colorFill = elementSeat.actived ? colorActive : colorBasic;
    // } else {
    //   let colorFill = elementSeat.actived ? colorActive : colorDefaultSeat;
    // }
    let sectionSeat = Object.values(this.seatSections).find((sectionData: any) => {
      return sectionData.section.id == this.activedSeat.section.id;
    });
    let color = sectionSeat ? this.activedSeat.colorSpecial || sectionSeat.section.color : this.colorDefaultSeat;

    let colorBasic = this.activedSeat.section
      ? color
      : this.colorDefaultSeat;

    let defaultColorActive = colorBasic;

    // Igual que en selectTicket: un bloqueo liberado conserva el color de su
    // bloqueo al dejar de estar seleccionado.
    if (this.activedSeat.blockedUnlocked) {
      defaultColorActive = this.blockedColorOf(this.activedSeat);
    }

    let elementActive = this.activedSeat._objects.find(
      (value) => value.type != 'text'
    );
    elementActive.set('fill', defaultColorActive);
    let rgb = hexToRgb(defaultColorActive);
    let defaultColorActiveText = '#000';
    if (rgb) {
      defaultColorActiveText =
        rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186 ? '#000' : '#fff';
    }
    let elementsText = this.activedSeat._objects.filter(
      (value) => value.type == 'text' || value.type == 'path'
    );
    elementsText.forEach((elementText) => {
      elementText.set('fill', defaultColorActiveText);
    });
  }

  deleteTicket(item: any, index: number) {
    this.activedSeat = item.element;
    this.activeChangeDefault();
    this.activedSeat = null;
    this.levelSelected = null;
    this.changeOpacitySections(true);
    // this.changeOpacitySections();
    this.totalPrice -= +this.selectedSeats[index].option.price;
    this.selectedSeats.splice(index, 1);
    this.canvas.renderAll();
  }

  canvasColorLevels(colorSelect: boolean = false) {
    let objects = this.canvas._objects;
    objects.forEach((element) => {
      let hiddenColor =
        (this.profile?.admin || (this.profile?.protocolo && this.organizer)) &&
          element.hiddenType
          ? element.hiddenType.color
          : this.colorDefaultHidden;
      // let levelColor = (this.profile?.admin || (this.profile?.protocolo && this.organizer)) && element.level ? element.level.color : this.colorDefaultSeat;
      let levelColor = element.level
        ? element.level.color
        : this.colorDefaultSeat;

      let defaultColor = element.hidden ? hiddenColor : levelColor;
      if (element.isSection) {
        changeSeatColor(
          element,
          colorSelect ? this.colorDefaultSelect : defaultColor
        );
      }
      if (element.groupSeat) {
        let arrayObject = element._objects[1];
        arrayObject._objects.forEach((seat) => {
          let hiddenColorSeat =
            (this.profile?.admin ||
              (this.profile?.protocolo && this.organizer)) &&
              seat.hiddenType
              ? seat.hiddenType?.color
              : this.colorDefaultHidden;
          // let levelColorSeat = (this.profile?.admin || (this.profile?.protocolo && this.organizer)) && seat.level ? seat.level.color : this.colorDefaultSeat;
          let levelColorSeat = seat.level
            ? seat.level.color
            : this.colorDefaultSeat;
          let defaultColorSeat = seat.hidden ? hiddenColorSeat : levelColorSeat;
          // Un bloqueo liberado no es "no disponible" ni una butaca normal de su
          // nivel: mantiene el color de su grupo (ver applyBlockedSelection).
          if (seat.blockedUnlocked) {
            defaultColorSeat = this.blockedColorOf(seat);
          }

          if (seat.eventSeat) {
            changeSeatColor(
              seat,
              colorSelect ? this.colorDefaultSelect : defaultColorSeat
            );
          }
        });
      }
    });
    this.canvas.renderAll();
  }

  getEnabledTickets() {
    this.optionSection = null;
    this.checkInvite = false;
    if (this.activedSeat && this.activedSeat.section) {
      if (this.singleSeatPass) {
        // Sin llamada de tarifas: la butaca ya viene filtrada por el mapa del
        // abono y el precio de cada evento lo da el desglose del back.
        // Dentro de la zona de Angular: aquí no hay petición que refresque la
        // vista y los eventos del canvas de Fabric pueden llegar desde fuera.
        this.zone.run(() => this.addTicket({ id: null, name: this.abono?.name, price: 0 }));
        return;
      }
      // Abono de precio fijo: no hay tarifa que elegir (la general la pone el
      // back); se enseña el precio del abono para el nivel de la butaca, y un
      // nivel sin precio en este evento no entra en el abono.
      if (this.fromAbono && isFixedPricePass(this.abono)) {
        const price = fixedPassPrice(this.abono, this.sessionSelected?.id, this.levelSelected?.id ?? null);
        this.zone.run(() => {
          if (price == null) {
            const zoneName = this.levelSelected?.name ? `«${this.levelSelected.name}»` : 'Esta zona';
            this.closeActived(false);
            this.dialog.open(InfoCardComponent, {
              panelClass: 'info-dialog',
              data: {
                icon: false,
                text: `${zoneName} no entra en el abono en este evento. Elige una butaca de otra zona.`,
                btnCancel: false,
              },
            });
            return;
          }
          this.addTicket({ id: null, name: this.abono?.public_name || this.abono?.name, price });
        });
        return;
      }
      // Cambiar API
      this.ticketsService.getTicketsBySessionSeat(this.sessionSelected.id, this.activedSeat.id)
        .subscribe({
          next: (res) => {
            if (res.data) {
              let tickets = res.data.sort((a, b) => b.price - a.price);
              tickets = tickets.filter((ticket: any) => ticket.active);
              tickets.forEach(element => {
                let price = element.price;
                let ticketSpecial = element.ticket_seats?.find((seat: any) => seat.seat_id == this.activedSeat.id);
                if (ticketSpecial) {
                  price = ticketSpecial.price;
                } else {
                  let levelTicket = element.ticket_levels?.find((level: any) => level.level_id == this.levelSelected?.id);
                  price = levelTicket ? levelTicket.price : element.price;
                }
                element.price = price;
              });
              // Para flujo de abono, solo mostrar la entrada con precio más alto
              const finalTickets = this.fromAbono ? [tickets[0]] : tickets;
              // Si solo hay un tipo de entrada, seleccionarlo automáticamente sin mostrar el panel
              if (finalTickets.length === 1) {
                this.addTicket(finalTickets[0]);
              } else {
                this.changeOpacitySections();
                this.optionSection = finalTickets;
              }
            }
          },
        });
    }
  }

  goBuyTickets() {
    let user = this.auth.getProfile();
    if (!user) {
      // En el tótem no se pide login: la compra cuelga del usuario del kiosco.
      if (this.totemActive) {
        this.auth.ensureTotemSession().subscribe((totemUser) => {
          if (totemUser) {
            this.goBuyTickets();
          } else {
            this.dialog.open(InfoCardComponent, {
              panelClass: 'info-dialog',
              data: {
                icon: true,
                text: '¡Vaya! No se ha podido iniciar la compra. Por favor, vuelve a intentarlo.',
                btnCancel: false,
              },
            });
          }
        });
        return;
      }
      // El mapa se usa entero sin cuenta (butacas, tipos de entrada, precios) y
      // el login se pide aquí, al añadir al carrito. Al conseguirlo se retoma
      // solo, sin tener que volver a pulsar: lo elegido va al carrito.
      const dialogRef = this.dialog.open(LoginComponent, {
        panelClass: ['info-dialog', 'dialog-login'],
        data: {
          exit: false,
          seats: true,
        },
      });
      // Dentro de la zona de Angular a propósito: el login con Google responde
      // desde su propio script y, si el cierre llega desde fuera, lo que venga
      // después (titular nominativo, errores del carrito) no repintaría.
      dialogRef.afterClosed().subscribe((res: any) => this.zone.run(() => {
        if (res?.login) {
          this.profile = this.auth.getProfile();
          this.goBuyTickets();
        }
      }));
      return;
    }
    if (user) {
      // Comprobar tickets maximos disponibles
      let errorTickets = false;
      let msg = '';
      // Payload para el carrito
      let payload = {
        cart_lines: []
      };
      this.selectedSeats.forEach(element => {
        payload.cart_lines.push({ id_event: this.event.id, id_session: this.sessionSelected.id, id_ticket: element.option.id, quantity: 1, id_seat: element.id });
      });

      payload.cart_lines.forEach((element) => {
        let ticket = this.ticketsEnabled.find(value => value.id === element.id_ticket);
        // En butaca única y en precio fijo la línea va sin entrada: la pone el back
        if (ticket?.max_tickets > 0) {
          let sameTickets = payload.cart_lines.filter(line => line.id_ticket === element.id_ticket);
          if (sameTickets.length > ticket.max_tickets) {
            // Mensaje de error, se ha superado el aforo permitido
            errorTickets = true;
            msg =
              'No se pueden seleccionar más de ' +
              sameTickets.length +
              ' entradas de tipo "' +
              ticket.name +
              '"';
          }
        }
      });
      if (errorTickets) {
        this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: false,
            text: msg,
            btnCancel: false,
          },
        });
      } else {
        // Si estamos en flujo de abono, cerrar el diálogo con los datos
        if (this.fromAbono) {

          this.dialogRef.close({
            cart_lines: payload.cart_lines,
            price: this.totalPrice,
            session: this.sessionSelected,
            seats: this.selectedSeats  // Incluir los asientos completos con toda su información
          });
        } else {
          // Flujo normal: Añadir al carrito.
          // En eventos nominativos, antes hay que confirmar el titular: el dato
          // se guarda en el perfil y desde ahí lo congela el backend en las
          // entradas al generar el pedido.
          this.nominativeService.ensureHolderData(this.event).subscribe((canContinue) => {
            if (!canContinue) {
              return;
            }
            // Coger el último carrito del usuario
            this.shoppingCart.getCartUser().subscribe({
              next: (res) => {
                if (res?.data && res.data.cart && res.data.cart.id_company != this.event.company.id) {
                  // Mostrar diálogo de error, no se pueden comprar varias entradas de diferentes organizadores
                  this.dialog.open(InfoCardComponent, {
                    panelClass: 'info-dialog',
                    data: {
                      icon: false,
                      text: 'No se pueden añadir entradas de diferentes organizadores en el mismo carrito. Por favor, finaliza la compra o vacía el carrito para continuar.',
                      btnCancel: false,
                    },
                  });
                  return;
                }
                this.addToCart(payload);
              }, error: (err) => {
                this.addToCart(payload);
              }
            });
          });
        }
      }
    }
  }

  addToCart(payload: any) {
    this.shoppingCart.addToCart(payload).subscribe({
      next: (res) => {
        this.dialogRef.close(payload);
      },
      error: (err) => {
        // El tope por persona lo comprueba el servidor sumando los pedidos
        // anteriores, así que salta también al volver al mapa con una entrada ya
        // en el carrito, cuando aquí no hay nada seleccionado que lo delate. El
        // mensaje viene redactado (nominativas, tope del gestor) y se enseña tal
        // cual: el genérico hablaba de una butaca ocupada por otra persona, que
        // no era lo que pasaba.
        const ruleMsg = err.error?.message === 'cart_add_failed_rules'
          ? err.error?.errors?.errors?.[0]
          : null;
        this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: false,
            text: ruleMsg || `Esta ${this.selectionNoun} está siendo reservada por otra persona en este momento. Si la compra no se completa en unos minutos, volverá a estar disponible.`,
            btnCancel: false
          }
        });
      }
    })
  }

  changeOpacitySections(showAll: boolean = false) {
    const sectionsLevel = this.sectionsEnabled.filter((section) => section.id_level == this.levelSelected?.id);
    const idsSectionsMap = sectionsLevel.map(section => section.id_section);
    if (this.mapBySections) {
      let objects = this.canvas._objects;
      if (this.levelSelected && !showAll) {
        if (idsSectionsMap.length > 0) {
          // Ocultar todos los que no son de la sección
          objects.forEach((element) => {
            const levelMatchesSelected = element.level === this.levelSelected.id
              || (this.levelSelected.id_level != null && element.level === this.levelSelected.id_level);
            if (element.isInfoSection && !levelMatchesSelected) {
              element.set('fill', '#DADADA');
            } else if (element.isInfoSection) {
              var oldFill = element.oldFill || element.fill;
              element.set('fill', oldFill);
            }
            if (element.groupSeat) {
              let arrayObject = element._objects[1];
              arrayObject._objects.forEach((seat) => {
                if (seat.actived) {
                  return;
                }
                if (seat.eventSeat && !idsSectionsMap.includes(seat.section?.id) && !seat.actived && !seat.hidden) {
                  if (!seat.oldFill && !seat.hidden) {
                    let oldFill = seat._objects.find((value) => value.type != 'text').fill;
                    seat.oldFill = oldFill && oldFill != '#DADADA' ? oldFill : null;
                  }
                  if (seat.hidden) return;
                  if (seat.actived) return;
                  changeSeatColor(
                    seat,
                    '#DADADA'
                  );
                } else if (seat.oldFill && !seat.actived && !seat.hidden) {
                  changeSeatColor(
                    seat,
                    seat.oldFill
                  );
                }
              });
            }
          });
        }
      } else {
        this.infoSectionActive = null;
        objects.forEach((element) => {
          if (element.isInfoSection) {
            var oldFill = element.oldFill || element.fill;
            element.set('fill', oldFill);
          }
          if (element.groupSeat) {
            let arrayObject = element._objects[1];
            arrayObject._objects.forEach((seat) => {
              if (seat.oldFill && !seat.actived && !seat.hidden) {
                changeSeatColor(
                  seat,
                  seat.oldFill
                );
              }
            });
          }
        });
      }
      this.canvas.renderAll();
    }
  }

  selectArea(level: any) {
    // Aquí tienes acceso al valor anterior antes de que cambie
    const previousLevel = this.previousLevelSelected;

    if (this.previousLevelSelected && this.previousLevelSelected.id == level.id) {
      this.previousLevelSelected = null;
      this.levelSelected = null;
      this.changeOpacitySections(true);
      return;
    }

    // Guardar el nivel anterior antes de actualizar
    this.previousLevelSelected = this.levelSelected;
    this.levelSelected = level;

    this.changeOpacitySections();
    // this.closeActived(false);
  }

  // ===== Navegación por zonas (vista general clicable + zoom a zona) =====

  // Punto de entrada: solo actúa si el mapa tiene la navegación activada y hay zonas.
  initZoneNavigation() {
    if (!this.zoneNavigation || !this.navPreview?.length || !this.canvas) {
      return;
    }
    // Asegurar que el canvas tiene dimensiones correctas antes de calcular bounds.
    const container = document.getElementById('canvas-container');
    if (container && (this.canvas.getWidth() === 0 || this.canvas.getHeight() === 0)) {
      const w = container.clientWidth || 800;
      const h = container.clientHeight || 600;
      this.canvas.setDimensions({ width: w, height: h });
    }
    this.drawNavPreview();
    this.enterOverview();
  }

  // Dibuja la escena del plano general: polígonos/rectángulos (zonas clicables si tienen
  // secciones asignadas), escenario y textos. Es un dibujo libre, independiente del mapa de
  // butacas, así que se renderiza tal cual viene en su propio sistema de coordenadas.
  drawNavPreview() {
    this.navZoneObjects = [];
    this.navPreview.forEach((obj: any) => {
      const type = obj.type;
      const cfg: any = { ...(obj.configuration || {}), objectId: obj.id ?? obj.configuration?.objectId };

      if (type === 'polygon' || type === 'rect' || type === 'ellipse') {
        const shape = type === 'rect'
          ? this.generateMapService.addRectObject(cfg)
          : type === 'ellipse'
            ? this.generateMapService.addEllipseObject(cfg)
            : this.generateMapService.addPoligonObject(cfg);
        const levels = Array.isArray(cfg.levels) ? cfg.levels : [];
        const shapes = Array.isArray(cfg.navZoneShapes) ? cfg.navZoneShapes : [];
        const isZone = levels.length > 0 || shapes.length > 0;
        shape.set({
          selectable: false,
          evented: isZone,
          hoverCursor: isZone ? 'pointer' : 'default',
          isInfoSection: false,
          previewScene: true,
          isNavZoneShape: isZone,
          navZone: isZone ? { levels, shapes, name: cfg.name ?? null } : null
        });
        this.canvas.add(shape);
        this.canvas.bringToFront(shape);
        shape.setCoords();
        this.navZoneObjects.push(shape);

        if (cfg.name && !cfg.hideLabel) {
          const label = new fabric.Text(cfg.name, {
            left: shape.left,
            top: shape.top,
            originX: 'center',
            originY: 'center',
            fontFamily: 'Satoshi-Regular',
            fontSize: cfg.labelFontSize || 40,
            angle: cfg.labelAngle || 0,
            fill: '#222222',
            selectable: false,
            evented: false,
            previewScene: true,
            isNavZoneLabel: true
          });
          this.canvas.add(label);
          this.canvas.bringToFront(label);
          label.setCoords();
          this.navZoneObjects.push(label);
        }
      } else if (type === 'scenary') {
        this.generateMapService.createScenary(
          this.canvas, cfg.fill || this.colorDefaultStage, this.screenElement, cfg, true
        ).then((res: any) => {
          if (res?.group) {
            res.group.set({ previewScene: true, selectable: false, evented: false });
            res.group.visible = this.inOverview;
            this.navZoneObjects.push(res.group);
            this.canvas.renderAll();
          }
        });
      } else if (type === 'text') {
        const text = new fabric.Textbox(cfg.text || '', {
          width: cfg.width || 200,
          height: cfg.height || 100,
          fontSize: cfg.fontSize || 24,
          lineHeight: cfg.lineHeight || 1,
          fontFamily: cfg.fontFamily || 'Satoshi-Regular',
          fill: cfg.fill || '#000000',
          left: cfg.left,
          top: cfg.top,
          scaleX: cfg.scaleX || 1,
          scaleY: cfg.scaleY || 1,
          angle: cfg.angle || 0,
          selectable: false,
          evented: false
        });
        (text as any).set('previewScene', true);
        this.canvas.add(text);
        text.setCoords();
        this.navZoneObjects.push(text);
      } else if ((type === 'image' || type === 'svg') && (cfg.svg || cfg.src)) {
        // Dibujo de fondo del plano general. Va al fondo para no tapar las zonas clicables, y
        // como se resuelve asíncrono fija su propia visibilidad (enterOverview ya pudo pasar).
        const source = cfg.svg
          ? this.generateMapService.addSvgObject(cfg.svg, cfg)
          : this.generateMapService.addImageObject(cfg.src, cfg);
        source.then((img: any) => {
          if (!img) {
            return;
          }
          img.set({ previewScene: true, selectable: false, evented: false, hoverCursor: 'default' });
          img.visible = this.inOverview;
          this.canvas.add(img);
          this.canvas.sendToBack(img);
          img.setCoords();
          this.navZoneObjects.push(img);
          this.canvas.renderAll();
        });
      }
    });
    this.canvas.renderAll();
  }

  // Vista general: oculta el mapa de butacas y muestra solo la escena del plano general.
  enterOverview() {
    this.inOverview = true;
    this.showingFullMap = false;
    this.selectedZone = null;
    this.setMapContentVisible(false);
    this.setNavZonesVisible(true);
    const bounds = this.getObjectsBounds(this.navZoneObjects);
    if (bounds) {
      this.fitToBounds(bounds, 0.05, 1, 60);
    }
    this.canvas.renderAll();
  }

  // Click en una zona: oculta el plano general y muestra SOLO esa zona (sus secciones de
  // butacas + los polígonos asociados a los niveles de esas secciones). El resto del mapa
  // —otras secciones, otros polígonos, escenario y textos— queda oculto hasta "Ver mapa
  // completo". El zoom encuadra los objetos visibles (secciones reales, no el polígono del
  // overview, que vive en otro sistema de coordenadas).
  onMinimapZoneSelected(zone: any): void {
    this.selectNavZone(zone);
  }

  selectNavZone(zone: any) {
    this.selectedZone = zone;
    this.inOverview = false;
    this.showingFullMap = false;
    this.levelSelected = null;
    this.previousLevelSelected = null;
    this.changeOpacitySections(true);
    this.setNavZonesVisible(false);
    const visibles = this.renderZoneOnly(zone);
    const bounds = this.getObjectsBounds(visibles);
    if (bounds) {
      this.fitToBounds(bounds, 0.2, 0.55, 40);
    }
    this.canvas.renderAll();
  }

  // Muestra SOLO lo de la zona: secciones de butacas cuyos id_level esté en zone.levels y los
  // polígonos (isInfoSection) cuyo nivel pertenezca a esos mismos niveles. Todo lo demás
  // (escenario, textos, otras secciones/polígonos) se oculta. Devuelve los objetos que
  // quedaron visibles para poder encuadrar el zoom.
  // Fallback de seguridad: si ningún grupo de butacas coincide (IDs desincronizados), se
  // muestra el mapa completo para no dejar la pantalla vacía.
  renderZoneOnly(zone: any): any[] {
    // zone.levels may contain local editor IDs (map_levels.id_level) or DB PKs (map_levels.id).
    // resolveLevel normalizes both to level.id (the DB PK that section.id_level references).
    const rawLevelRefs = (zone?.levels || []).map((id: any) => +id);
    const resolvedLevels = rawLevelRefs.map((ref: any) => this.resolveLevel(ref)).filter(Boolean);
    const levelIds = resolvedLevels.length > 0
      ? resolvedLevels.map((l: any) => +l.id)
      : rawLevelRefs;
    const sectionIds = this.sectionsEnabled
      .filter((s: any) => levelIds.includes(+(s.id_level ?? -1)))
      .map((s: any) => +(s.id_section ?? s.id));

    const zoneShapeIds: string[] = Array.isArray(zone?.shapes) ? zone.shapes : [];

    const anyMatch = this.canvas.getObjects().some((obj: any) => {
      if (obj.previewScene) return false;
      if (obj.groupSeat) {
        const firstSeat = obj._objects?.[1]?._objects?.find((s: any) => s.section?.id != null);
        return firstSeat && sectionIds.includes(+firstSeat.section.id);
      }
      if (zoneShapeIds.length > 0 && obj.objectId) {
        return zoneShapeIds.includes(obj.objectId);
      }
      return false;
    });
    if (!anyMatch) {
      this.showFullMap();
      return [];
    }

    const visibles: any[] = [];
    this.canvas.getObjects().forEach((obj: any) => {
      if (obj.previewScene) return; // overview, lo gestiona setNavZonesVisible
      let visible = false;
      if (obj.groupSeat) {
        const firstSeat = obj._objects?.[1]?._objects?.find((s: any) => s.section?.id != null);
        visible = firstSeat?.section?.id != null && sectionIds.includes(+firstSeat.section.id);
      } else if (obj.isSection && obj.section?.id != null) {
        visible = sectionIds.includes(+obj.section.id);
      } else if (obj.isInfoSection && obj.level != null) {
        const lvl = this.resolveLevel(obj.level);
        visible = lvl != null && levelIds.includes(+lvl.id);
      } else if (zoneShapeIds.length > 0 && obj.objectId) {
        visible = zoneShapeIds.includes(obj.objectId);
      } else {
        visible = false;
      }
      obj.visible = visible;
      if (visible) visibles.push(obj);
    });
    return visibles;
  }

  // "Ver mapa completo": muestra TODO el mapa real (todas las secciones, polígonos,
  // escenario y textos) y encuadra al conjunto. Oculta el plano general.
  showFullMap() {
    this.inOverview = false;
    this.showingFullMap = true;
    this.setNavZonesVisible(false);
    const realObjects = this.canvas.getObjects().filter((o: any) => !o.previewScene);
    realObjects.forEach((o: any) => { o.visible = true; });
    const bounds = this.getObjectsBounds(realObjects);
    if (bounds) {
      this.fitToBounds(bounds, 0.05, 1, 60);
    }
    this.canvas.renderAll();
  }

  // Resuelve un id de nivel contra levelsEnabled probando id, id_level y orderBuy
  // (mismo criterio de normalización que recreatePolygon/recreateRect).
  resolveLevel(levelRef: any): any {
    return this.levelsEnabled.find((l: any) => +l.id === +levelRef)
      || this.levelsEnabled.find((l: any) => l.id_level != null && +l.id_level === +levelRef)
      || this.levelsEnabled.find((l: any) => l.orderBuy != null && +l.orderBuy === +levelRef);
  }

  // Conjunto de ids de nivel (normalizados a level.id) de las secciones de una zona.
  getZoneLevelIds(sectionIds: number[]): number[] {
    const ids = (sectionIds || []).map((id: any) => +id);
    const levelIds = this.sectionsEnabled
      .filter((s: any) => ids.includes(+(s.id_section ?? s.id)))
      .map((s: any) => this.resolveLevel(s.id_level)?.id ?? +s.id_level)
      .filter((id: any) => id != null)
      .map((id: any) => +id);
    return [...new Set(levelIds)];
  }

  backToOverview() {
    this.enterOverview();
  }

  // Solo alterna visibilidad (no 'evented') para no cambiar el comportamiento original de los
  // objetos del mapa. Fabric no selecciona objetos con visible=false, así que basta con esto.
  // Los objetos de la escena preview se omiten (los gestiona setNavZonesVisible).
  setMapContentVisible(visible: boolean) {
    this.canvas.getObjects().forEach((o: any) => {
      if (o.previewScene) {
        return;
      }
      o.visible = visible;
    });
  }

  setNavZonesVisible(visible: boolean) {
    this.navZoneObjects.forEach((o: any) => {
      o.visible = visible;
    });
  }

  getObjectsBounds(objects: any[]) {
    if (!objects || objects.length === 0) {
      return null;
    }
    // getBoundingRect(true) devuelve coordenadas de MUNDO (sin viewport transform) en Fabric 5.x.
    // calcACoords() no aplica viewportTransform; calcLineCoords() sí. absolute=true → aCoords.
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    objects.forEach((obj: any) => {
      const b = obj.getBoundingRect(true);
      minX = Math.min(minX, b.left);
      minY = Math.min(minY, b.top);
      maxX = Math.max(maxX, b.left + b.width);
      maxY = Math.max(maxY, b.top + b.height);
    });
    return { minX, minY, maxX, maxY };
  }

  // Ajusta el viewport para encuadrar unos límites (mismo cálculo que el fit inicial).
  fitToBounds(bounds: { minX: number, minY: number, maxX: number, maxY: number }, minZoom: number = 0.2, maxZoom: number = 0.5, margin: number = 40) {
    if (!this.canvas || !bounds) {
      return;
    }
    const containerWidth = this.canvas.getWidth();
    const containerHeight = this.canvas.getHeight();
    const usableHeight = containerHeight - this.getBottomOverlayInset();
    const contentWidth = Math.max(bounds.maxX - bounds.minX, 1);
    const contentHeight = Math.max(bounds.maxY - bounds.minY, 1);
    const contentCenterX = bounds.minX + contentWidth / 2;
    const contentCenterY = bounds.minY + contentHeight / 2;
    const zoomX = (containerWidth - margin * 2) / contentWidth;
    const zoomY = (usableHeight - margin * 2) / contentHeight;
    let zoom = Math.min(zoomX, zoomY);
    zoom = Math.min(Math.max(zoom, minZoom), maxZoom);
    const offsetX = containerWidth / 2 - contentCenterX * zoom;
    const offsetY = usableHeight / 2 - contentCenterY * zoom;
    this.canvas.setViewportTransform([zoom, 0, 0, zoom, offsetX, offsetY]);
    this.canvas.renderAll();
  }

  // El panel "Entradas seleccionadas" flota sobre el canvas en móvil (position: absolute),
  // por lo que esa franja inferior no es visible aunque forme parte de la altura del contenedor.
  private getBottomOverlayInset(): number {
    // Paneles que flotan sobre la franja inferior del canvas: el de compra en
    // móvil (.info-select-map) y el resumen de butaca del abono (.abono-selection-summary,
    // fijado abajo en modo abono). Se descuentan del alto útil para que el zoom
    // no encuadre contenido debajo de ellos.
    const selectors = ['.info-select-map', '.abono-selection-summary'];
    for (const sel of selectors) {
      const el = document.querySelector(sel) as HTMLElement | null;
      if (!el) {
        continue;
      }
      const position = window.getComputedStyle(el).position;
      if (position === 'absolute' || position === 'fixed') {
        return el.getBoundingClientRect().height;
      }
    }
    return 0;
  }

  // HiddenSeats
  openFormCode() {
    this.discountObject = null;
    this.savedCode = null;
    this.openFormDiscount = !this.openFormDiscount;
    if (this.errorCode) {
      this.errorCode = false;
      this.hiddenCode = null;
    }
  }

  applyCode() {
    this.hiddenCode = this.hiddenCode.trim();
    this.ticketsService
      .checkHiddenCode(this.hiddenCode, this.sessionSelected.id)
      .subscribe({
        next: (res) => {
          if (res) {
            this.discountObject = res;
            this.errorCode = false;
            this.savedCode = this.hiddenCode;
            if (res.percentage == 100) {
              this.invite = true;
            }
            this.desactiveHiddenSeat(true);
          }
        },
        error: (err) => {
          this.errorCode = true;
          this.invite = false;
        },
      });
  }

  desactiveHiddenSeat(active: boolean) {
    let objects = this.canvas._objects;
    objects.forEach((element) => {
      element.hoverCursor = 'pointer';
      if (element.groupSeat) {
        let arrayObject = element._objects[1];
        arrayObject._objects.forEach((seat) => {
          seat.visible = seat.isVisible;
          seat.eventSeat = seat.eventSeat && seat.isVisible;
          let hiddenSeat = this.discountObject?.hiddenSeat?.seats?.find(
            (value) =>
              value.section.id == seat.section?.id &&
              value.section.name == seat.section?.name &&
              value.row == seat.row &&
              value.seat == seat.seat &&
              value.level?.orderBuy == seat.level?.orderBuy
          );
          if (hiddenSeat) {
            seat.hidden = !active;
            seat.border = active;
            if (this.invite) {
              seat.invite = true;
            }
          }
          let exist = this.buysBuySelect.includes(seat.id);
          if (exist) {
            seat.hidden = true;
          }
          if (seat.eventSeat) {
            seat.hoverCursor = 'pointer';
            seat.selectable = true;
          }
          if (seat.hidden) {
            seat.hoverCursor = 'default';
            seat.selectable = false;
          }
        });
      }
      if (!element.eventSeat || element.hidden) {
        element.selectable = false;
        element.hoverCursor = 'default';
      }
    });
    this.canvasColorLevels();
  }

  deleteCode() {
    this.savedCode = null;
    this.errorCode = false;
    this.desactiveHiddenSeat(false);
    this.discountObject = null;
    this.invite = false;
    this.activedSeat = null;
    this.levelSelected = null;
    this.changeOpacitySections(true);
  }

  openedLegend() {
    // if (window.innerWidth < 768) {
    this.openLegend = !this.openLegend;
    // }
  }

  // Construye las filas de la leyenda a partir de la config del mapa (legendConfig) fusionada
  // con los datos vivos (niveles y grupos de bloqueo del evento). Si no hay config guardada,
  // reproduce las dos filas por defecto de siempre (retrocompatible).
  buildLegendEntries(): void {
    const cfg = this.legendConfig;

    if (!cfg) {
      this.legendEntries = [
        { label: 'No disponibles', color: this.colorDefaultHidden },
        { label: 'Seleccionadas', color: this.colorDefaultSelect },
        ...this.blockedLegendEntries(),
      ];
      return;
    }

    const entries: { label: string, color: string }[] = [];
    const states = cfg.states || {};

    if (states.available?.show) {
      entries.push({ label: states.available.label || 'Disponible', color: this.colorDefaultSeat });
    }
    if (states.selected?.show) {
      entries.push({ label: states.selected.label || 'Seleccionada', color: this.colorDefaultSelect });
    }
    if (states.occupied?.show) {
      entries.push({ label: states.occupied.label || 'No disponible', color: this.colorDefaultHidden });
    }

    // Zonas de precio: una fila por nivel vivo (nombre + color reales).
    if (cfg.levels?.show) {
      (this.objectMap?.levels || []).forEach((level: any) => {
        if (level?.name && level?.color) {
          entries.push({ label: level.name, color: level.color });
        }
      });
    }

    // Grupos de bloqueo/reservados del evento (solo nombre + color; sin exponer butacas).
    if (cfg.blockedGroups?.show) {
      (this.objectMap?.blocked_groups_legend || []).forEach((group: any) => {
        if (group?.name && group?.color) {
          entries.push({ label: group.name, color: group.color });
        }
      });
    }

    entries.push(...this.blockedLegendEntries());

    this.legendEntries = entries;

    // Estado inicial abierto/cerrado según la config (por defecto cerrado).
    if (cfg.defaultOpen) {
      this.openLegend = true;
    }
  }

  /**
   * Filas de leyenda de los bloqueos del recinto, solo mientras están liberados:
   * en cuanto se pintan con el color de su grupo hay que decir qué es cada color
   * y que, a diferencia del resto de butacas marcadas, se pueden elegir.
   */
  private blockedLegendEntries(): { label: string, color: string }[] {
    if (!this.blockedUnlocked) return [];

    return this.blockedGroups.map((group: any) => ({
      label: `${group.name} (asignable)`,
      color: group.color,
    }));
  }
}

function changeSeatColor(elementSeat, color) {
  let elementStroke = elementSeat._objects.find(
    (value) => value.type != 'text'
  );
  elementStroke.set('fill', color);
  let rgb = hexToRgb(color);
  let textColor =
    rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186 ? '#000' : '#fff';
  let elementsText = elementSeat._objects.filter(
    (value) => value.type == 'text' || value.type == 'path'
  );
  elementsText.forEach((elementText) => {
    elementText.set('fill', textColor);
  });
  return elementSeat;
}

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    }
    : null;
}

function keepPositionInBounds(canvas: any, e: any) {
  const zoom = canvas.getZoom();
  const vpt = canvas.viewportTransform;
  const vw = canvas.getWidth();
  const vh = canvas.getHeight();

  let newTx = vpt[4] + e.e.movementX;
  let newTy = vpt[5] + e.e.movementY;

  // Límites de paneo basados en el bounding box real del contenido (en coordenadas de
  // objeto, sin viewportTransform), para que el mapa no se pueda sacar del todo de la vista.
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const obj of canvas.getObjects()) {
    const r = obj.getBoundingRect(true, true); // absolute=true → sin viewportTransform
    if (r.left < minX) minX = r.left;
    if (r.top < minY) minY = r.top;
    if (r.left + r.width > maxX) maxX = r.left + r.width;
    if (r.top + r.height > maxY) maxY = r.top + r.height;
  }

  if (isFinite(minX)) {
    // Cuánto contenido debe permanecer visible dentro del viewport para no perder el mapa.
    const margin = Math.min(vw, vh) * 0.2;

    // Rango de traslación permitido para que el contenido no salga del viewport.
    const txMin = margin - maxX * zoom;
    const txMax = vw - margin - minX * zoom;
    const tyMin = margin - maxY * zoom;
    const tyMax = vh - margin - minY * zoom;

    // Solo restringimos cuando el contenido es mayor que el viewport (rango válido); si es
    // más pequeño (rango invertido) dejamos mover libremente para no bloquear el paneo.
    if (txMin <= txMax) newTx = Math.min(Math.max(newTx, txMin), txMax);
    if (tyMin <= tyMax) newTy = Math.min(Math.max(newTy, tyMin), tyMax);
  }

  canvas.relativePan(new fabric.Point(newTx - vpt[4], newTy - vpt[5]));
  return canvas;
}
